// src/components/Home.js
import React from "react";
import { useNavigate } from "react-router-dom";


const Home = () => {
  const navigate = useNavigate();
  const handleClick = () => {
   navigate("/contact"); // redirects to Contact page
  };

  return (
    <>
      <section className="hero" id="home">
        <h2>Donate Blood, Save Lives</h2>
        <p>
          Your generous contribution can help save countless lives. Help us keep the lifeline flowing!
        </p>
        <button className="cta-btn" onClick={handleClick}>
          Become a Donor
        </button>
      </section>

      <section className="stats" id="stats">
        <div className="stat-card">
          <div className="stat-count">5000+</div>
          <div className="stat-label">Successful Donations</div>
        </div>
        <div className="stat-card">
          <div className="stat-count">125</div>
          <div className="stat-label">Blood Donation Camps</div>
        </div>
        <div className="stat-card">
          <div className="stat-count">6000+</div>
          <div className="stat-label">Happy Beneficiaries</div>
        </div>
        <div className="stat-card">
          <div className="stat-count">50+</div>
          <div className="stat-label">Active Volunteers</div>
        </div>
      </section>

      <section id="about" style={{ maxWidth: "900px", margin: "3rem auto", padding: "0 1rem" }}>
        <h2 style={{ textAlign: "center", color: "#d32f2f" }}>About Spandan Blood Bank</h2>
        <p style={{ lineHeight: "1.6", fontWeight: 300 }}>
          Spandan Blood Bank is committed to providing safe and timely blood to patients in need.
          Founded in 2024, we have served thousands of individuals, supporting hospitals across the region.
          Our dedicated team of volunteers and staff ensure every donation is handled with utmost care and professionalism.
        </p>
        <p style={{ lineHeight: "1.6", fontWeight: 300 }}>
          Join us as a donor, volunteer, or supporter and make a positive impact on lives.
          Together, we can ensure no patient ever has to wait for the gift of life.
        </p>
      </section>
    </>
  );
};

export default Home;
